import { render } from "./TheHelixLoading.vue?vue&type=template&id=21ff224e&scoped=true"
const script = {}

import "./TheHelixLoading.vue?vue&type=style&index=0&id=21ff224e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ff224e"]])

export default __exports__